import types from "../../../constants/action-types"

export const setSaved = (payload) => ({
  type: types.SET_SAVEDS,
  payload,
})

// export const setFavourites = (payload) => {
//   return {
//     type: types.SET_FAVOURITES,
//     payload,
//   }
// }

export const setToken = (payload) => ({
  type: types.SET_TOKEN,
  payload,
})

export const fetchUserCreditionals = () => ({
  type: types.GET_USERDATAS,
  // payload,
})

export const setUsername = (payload) => ({
  type: types.SET_USERNAME,
  payload,
})

export const fetChAllPatterns = (payload) => ({
  type: types.GET_PATTERNS_ALL,
  payload,
})

export const clearUserDatas = () => {
  const currentLang = localStorage.getItem("lang")
  localStorage.clear()
  localStorage.setItem("lang", currentLang)
  // localStorage.removeItem("mmbs_access_token")
  // localStorage.removeItem("user")
  // localStorage.removeItem("visitorId")
  return {
    type: types.CLEAR_USERDATAS,
  }
}
